import React, { useMemo } from "react";
import ShowContainer from "../../mui/ShowContainer";
import CustomCarousel from "../../mui/custom-carousel/CustomCarousel.jsx";
import "./type-games-menu.scss";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../../store/index.ts";
import CusImage from "../../custom_image/CusImage.jsx";
import { useNavigate } from "react-router-dom";
import IconMenuCircle from "../../mui/JSXIcons/IconMenuCircle.jsx";

export default function TypeGamesMenu({ hideLobby }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const isLsm = useAppSelector((state) => state.deviceSize.isLsm);
  const isDesktop = useAppSelector((state) => state.deviceSize.isDesktop);
  const isSmallDesktop = useAppSelector((state) => state.deviceSize.isSmallDesktop);
  const isMenuAbsolute = useAppSelector((state) => state.deviceSize.isMenuAbsolute);
  const isBigDesktop = useAppSelector((state) => state.deviceSize.isBigDesktop);
  const isExtraSmall = useAppSelector((state) => state.deviceSize.isExtraSmall);
  const allCategories = useAppSelector((state) => state.games.categoryList);
  const categoryWager = useAppSelector((state) => state.games.categoryWager);
  const categoryWagerId = categoryWager.id;

  const categories = useMemo(() => {
    return allCategories.filter((el) => el.groupGameType);
  }, [allCategories, categoryWagerId]);

  const getItemsBySize = () => {
    if (isExtraSmall) return 2;
    if (!isDesktop) return 3;
    if (isLsm) return 4;
    if (isSmallDesktop) return 5;
    if (isMenuAbsolute) return 6;
    if (!isBigDesktop) return 7;
    return 8;
  };
  const itemsBySize = getItemsBySize();
  const isLobby = !hideLobby;
  const isManyItems = categories.length + isLobby > itemsBySize;

  const Lobby = () => (
    <button type="button" className={`type-game-menu__item`} onClick={() => navigate(`/`)}>
      <div className="type-game-menu__item__icon">
        <IconMenuCircle />
      </div>
      <div className="type-game-menu__item__info">
        <span className="type-game-menu__item__text">{t("Lobby")}</span>
        <span className="type-game-menu__item__count">{t("All games")}</span>
      </div>
    </button>
  );

  const Folders = () =>
    categories.map((item) => {
      const gameLength = item.games?.length ?? 0;
      const game = item.games?.[0];
      const navigateUrl = item.id == categoryWagerId ? `/wager_games` : `/categories/${item.id}`;

      return (
        <button
          key={item.id + Math.random()}
          type="button"
          className={`type-game-menu__item`}
          title={item.name}
          onClick={() => navigate(navigateUrl)}>
          <div className="type-game-menu__item__icon">
            {game.image && <CusImage url={game.image} alt={`image_${item.name}`} />}
          </div>
          <div className="type-game-menu__item__info">
            <span className="type-game-menu__item__text">{item.name}</span>
            <span className="type-game-menu__item__count">
              {t("games_count", { count: gameLength, defaultValue: `${gameLength} игр` })}
            </span>
          </div>
        </button>
      );
    });

  return (
    <ShowContainer condition={categories.length > 0}>
      {isManyItems ? (
        <CustomCarousel
          className="type-game-menu"
          loop={false}
          autoplay={false}
          slidesPerView={itemsBySize}
          spaceBetween={8}
          freeMode={true}>
          {isLobby && <Lobby />}
          {Folders()}
        </CustomCarousel>
      ) : (
        <nav className="type-game-menu">
          {isLobby && <Lobby />}
          <Folders />
        </nav>
      )}
    </ShowContainer>
  );
}
